import { ImageFullscreen } from "@/components/modal/imageFullscreen";
import { TypeDefaultImage } from "@/lib/image";
import { Attachment } from "@/lib/types";
import { cn } from "@/lib/utils";
import { ImageIcon } from "lucide-react";
import {
  CATALOG_THUMBNAIL_BOX_CLASS,
  CATALOG_THUMBNAIL_IMAGE_CLASS,
} from "./catalogMediaThumbnail";

interface ExemplaireThumbnailProps {
  /** Attachments déjà filtrés par statut de publication. */
  attachments: Attachment[];
  type: TypeDefaultImage;
  alt: string;
}

/**
 * Vignette 100×100 pour une ligne d'exemplaire (Sculpture / Multiple / Tirage).
 * - Photo présente : cliquable → plein écran via `ImageFullscreen`.
 * - Aucune photo : placeholder neutre NON cliquable.
 * Rendu identique côté Prévisu (ici) et Front CR pour rester conforme.
 */
export function ExemplaireThumbnail({
  attachments,
  type,
  alt,
}: ExemplaireThumbnailProps) {
  const hasImage = attachments.length > 0;

  if (!hasImage) {
    return (
      <div
        className={cn(
          CATALOG_THUMBNAIL_BOX_CLASS,
          "self-start rounded border border-dashed border-gray-200 bg-gray-50 text-gray-300",
        )}
        aria-hidden="true"
      >
        <ImageIcon className="h-6 w-6" />
      </div>
    );
  }

  return (
    <div className={cn(CATALOG_THUMBNAIL_BOX_CLASS, "self-start items-start")}>
      <ImageFullscreen
        media={{
          attachments,
          type,
          alt,
          width: 100,
          height: 100,
          // `!object-top` : ancre le contenu en haut de la box 100×100
          // (et écrase le `object-center` du helper partagé). Parité Prévisu/Front.
          className: cn(CATALOG_THUMBNAIL_IMAGE_CLASS, "!object-top"),
        }}
      />
    </div>
  );
}
